<template>
  <div class="card card-custom">
    <div class="card-header d-block">
      <div class="card-title">
        <h3 class="card-label">{{ $t('REISETERMINE.RELEASEPROZESS.VORGANGTITLE') }}</h3>
      </div>

      <div class="card-toolbar">
        <ul class="nav nav-tabs nav-bold nav-tabs-line">
          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, releasepruefungstab: 'teilnehmer' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'teilnehmer' }" :href="href">
                <span class="nav-icon"><i class="fas fa-user-check"></i></span>
                <span class="nav-text">Teilnehmerdaten</span>
              </a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, releasepruefungstab: 'reiseleistungen' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'reiseleistungen' }" :href="href">
                <span class="nav-icon"><i class="far fa-handshake"></i></span>
                <span class="nav-text">Gebuchte Reiseleistungen & Listenversand</span>
              </a>
            </router-link>
          </li>
          <li v-if="!isReiseOhneFlugComputed" class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, releasepruefungstab: 'fluege' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'fluege' }" :href="href">
                <span class="nav-icon"><i class="fas fa-plane"></i></span>
                <span class="nav-text">Flüge</span>
              </a>
            </router-link>
          </li>
          <li v-if="!isReiseOhneFlugComputed" class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, releasepruefungstab: 'transfer' },
              }"
              v-slot="{ href }"
            >
              <a class="nav-link" :class="{ active: activeTabFromRouter === 'transfer' }" :href="href">
                <span class="nav-icon"><i class="fas fa-bus"></i></span>
                <span class="nav-text">Transfer</span>
              </a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link
              :to="{
                path: '',
                query: { ...this.$route.query, releasepruefungstab: 'optionalsAndExtensions' },
              }"
              v-slot="{ href }"
            >
              <a
                class="nav-link"
                :class="{ active: activeTabFromRouter === 'optionalsAndExtensions' }"
                :href="href"
              >
                <span class="nav-icon"><i class="fas fa-suitcase"></i></span>
                <span class="nav-text">Optionals & Verlängerungen</span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
    <div class="card-body">
      <div v-if="!isInitialLoading" class="tab-content">
        <div
          v-show="activeTabFromRouter === 'teilnehmer'"
          :class="{ show: activeTabFromRouter === 'teilnehmer' }"
          class="tab-pane active"
        >
          <ReiseterminCardVorgaengeReleaseProcessTeilnehmer
            v-if="vorgaenge"
            :isLoading="isLoading"
            :reiseterminStartdatum="reiseterminZeitraum.start"
            :reiseterminEnddatum="reiseterminZeitraum.end"
            :reiseterminObj="reiseterminObj"
            :konfiguration="gueltigeKonfiguration"
            :vorgaenge="filteredVorgaenge"
            :isReiseterminInReleasePruefung="isReiseterminInReleasePruefung"
            :passdatenCheckRequired="passdatenCheckRequired"
            :dokumenteCheckRequired="dokumenteCheckRequired"
            @workflow-updated="emitReleaseprocessUpdated"
          ></ReiseterminCardVorgaengeReleaseProcessTeilnehmer>
        </div>
        <div
          v-show="activeTabFromRouter === 'reiseleistungen'"
          :class="{ show: activeTabFromRouter === 'reiseleistungen' }"
          class="tab-pane active"
        >
          <ReiseterminCardVorgaengeReleaseProcessReiseleitungen
            v-if="vorgaenge"
            :isLoading="isLoading"
            :vorgaenge="filteredVorgaenge"
            :passdatenCheckRequired="passdatenCheckRequired"
            :reiseterminObj="reiseterminObj"
            :isReiseterminInReleasePruefung="isReiseterminInReleasePruefung"
            :dokumenteCheckRequired="dokumenteCheckRequired"
            :transferData="transferData"
            @release-process-step-updated="saveReleaseprozessProcess"
            @release-process-step-updated-multi="saveReleaseprozessProcessMulti"
            @workflow-updated="emitReleaseprocessUpdated"
          ></ReiseterminCardVorgaengeReleaseProcessReiseleitungen>
        </div>
        <div
          v-if="!isReiseOhneFlugComputed"
          v-show="activeTabFromRouter === 'fluege'"
          :class="{ show: activeTabFromRouter === 'fluege' }"
          class="tab-pane active"
        >
          <ReiseterminCardVorgaengeReleaseProcessFluege
            v-if="vorgaenge"
            :isLoading="isLoading"
            :reiseterminObj="reiseterminObj"
            :passdatenCheckRequired="passdatenCheckRequired"
            :dokumenteCheckRequired="dokumenteCheckRequired"
            :blankVorgaenge="filteredVorgaenge"
            :transferData="transferData"
          ></ReiseterminCardVorgaengeReleaseProcessFluege>
        </div>
        <div
          v-show="activeTabFromRouter === 'optionalsAndExtensions'"
          :class="{ show: activeTabFromRouter === 'optionalsAndExtensions' }"
          class="tab-pane active"
        >
          <ReisetermineCardVorgaengeOptionalsAndExtensions
            :vorgaenge="filteredVorgaenge"
          ></ReisetermineCardVorgaengeOptionalsAndExtensions>
        </div>

        <div
          v-if="!isReiseOhneFlugComputed"
          v-show="activeTabFromRouter === 'transfer'"
          :class="{ show: activeTabFromRouter === 'transfer' }"
          class="tab-pane active"
        >
          <ReisetermineCardVorgaengeTransfer
            :reiseterminId="reiseterminObj.id"
            :reiseterminkuerzel="reiseterminObj.reiseterminkuerzel"
            :metadata="reiseterminObj.metadata"
            :pax="reiseterminObj.pax"
            :vorgaenge="filteredVorgaenge"
          ></ReisetermineCardVorgaengeTransfer>
        </div>
      </div>
      <div v-else class="tab-content">
        <b-skeleton-table :rows="5" :columns="6"></b-skeleton-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER,
  SAVE_VORANG_RELEASEPROCESS_STEP1,
  SAVE_VORANG_RELEASEPROCESS_STEP1_ARRAY,
  SAVE_TRANSFERPLANUNG_PROCESS,
} from '@/core/vorgaenge/stores/vorgaenge.module';
import { GET_RELEASEPROCESS_TRIGGERS } from '@/core/produkte/reisetermine/stores/reisetermin-triggers.module';
import ReiseterminCardVorgaengeReleaseProcessTeilnehmer from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-release-process-teilnehmer.vue';
import ReiseterminCardVorgaengeReleaseProcessReiseleitungen from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-release-process-reiseleistungen.vue';
import ReiseterminCardVorgaengeReleaseProcessFluege from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-release-process-fluege.vue';
import { isReiseOhneFlug } from '@/core/common/helpers/utils.js';
import ReisetermineCardVorgaengeOptionalsAndExtensions from './reisetermine-card-vorgaenge-optionalsAndExtensions.vue';
import ReisetermineCardVorgaengeTransfer from '@/components/produkte/reisetermine/reisetermin-card-vorgaenge-transfer.vue';
import apiService from '@/core/common/services/api.service';
import { getReiseterminZeitraum } from '@/core/vorgaenge/helpers/teilnehmer-passdaten.utils';

export default {
  name: 'ReiseterminViewCardVorgaengeReleaseProcess',
  components: {
    ReiseterminCardVorgaengeReleaseProcessTeilnehmer,
    ReiseterminCardVorgaengeReleaseProcessReiseleitungen,
    ReiseterminCardVorgaengeReleaseProcessFluege,
    ReisetermineCardVorgaengeOptionalsAndExtensions,
    ReisetermineCardVorgaengeTransfer,
  },
  props: {
    reiseterminObj: { type: Object },
    isReiseterminInReleasePruefung: { type: Boolean },
    isInTransferplanung: { type: Boolean, default: false },
    defaultTab: { type: Number },
    gueltigeKonfiguration: { type: Object },
  },
  data() {
    return {
      transferData: {},
    };
  },
  async mounted() {
    if (Array.isArray(this.vorgaenge) && this.vorgaenge.length <= 0 && !this.isLoading) {
      this.getTeilnehmerAndFluege(this.reiseterminObj.id);
    }
    if (this.reiseterminObj?.id) {
      this.loadTransferData(this.reiseterminObj.id);
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.vorgaenge.isLoading,
      isInitialLoading: state => state.vorgaenge.isInitialLoading,
      vorgaenge: state => state.vorgaenge.vorgaenge,
    }),
    isReiseOhneFlugComputed() {
      return isReiseOhneFlug(this.reiseterminObj?.metadata);
    },
    filteredVorgaenge() {
      return this.vorgaenge.filter(
        vorgang =>
          vorgang.blankState === 'Buchung' ||
          /* vorgang.blankState === 'StornierteBuchung' || */ vorgang.isReleased
      );
    },
    activeTabFromRouter() {
      return this.$route.query.releasepruefungstab || 'teilnehmer';
    },
    // Zeitfenster des Reisetermins (Abreisedatum bis Enddatum),
    // wird für den Geburtstags-Hinweis und die Passgültigkeitsprüfung der Teilnehmer benötigt
    reiseterminZeitraum() {
      return getReiseterminZeitraum(this.reiseterminObj);
    },
    dokumenteCheckRequired() {
      return this.gueltigeKonfiguration?.dokumente;
    },
    passdatenCheckRequired() {
      return this.gueltigeKonfiguration?.passdaten;
    },
  },
  watch: {
    async reiseterminObj() {
      this.getTeilnehmerAndFluege(this.reiseterminObj.id);
      if (this.reiseterminObj?.id) {
        this.loadTransferData(this.reiseterminObj.id);
      }
    },
    isInitialLoading(isLoading) {
      if (!isLoading && this.$route.query.scrollToFlugdaten) {
        const element = document.getElementById('reiseterminCardVorgaengeReleaseProcess');
        const offset = element.getBoundingClientRect();
        if (element) {
          setTimeout(() => {
            const headerOffset = window.innerWidth < 1920 ? 190 + 65 - 350 : 190 + 65 - 50;
            window.scrollTo({
              top: offset.y - headerOffset,
              left: 0,
              behavior: 'smooth',
            });
          }, 100);
        }
      }
    },
  },
  methods: {
    emitReleaseprocessUpdated() {
      this.$emit('releaseprocess-updated');
    },
    async saveTransferplanungProcess(vorgangId, transferplanungObject) {
      await this.$store
        .dispatch(SAVE_TRANSFERPLANUNG_PROCESS, {
          id: vorgangId,
          transferplanungObject: transferplanungObject,
        })
        .then(() => {
          this.toast(this.$t('WORKFLOWS.COMMON.SAVED'));
        });
    },
    async saveReleaseprozessProcess(vorgangId, releaseProcessObject) {
      await this.$store
        .dispatch(SAVE_VORANG_RELEASEPROCESS_STEP1, {
          id: vorgangId,
          releaseProcessObject: releaseProcessObject,
        })
        .then(() => {
          this.toast(this.$t('WORKFLOWS.COMMON.SAVED'));
          const { reiseterminId } = this.$route.params;
          this.$store.dispatch(GET_RELEASEPROCESS_TRIGGERS, reiseterminId);
        });
    },
    async saveReleaseprozessProcessMulti(releaseProcessObjectsArray) {
      await this.$store
        .dispatch(SAVE_VORANG_RELEASEPROCESS_STEP1_ARRAY, {
          reiseterminId: this.reiseterminObj.id,
          releaseProcessObjectsArray: releaseProcessObjectsArray,
        })
        .then(() => {
          this.toast(this.$t('WORKFLOWS.COMMON.SAVED'));
          const { reiseterminId } = this.$route.params;
          this.$store.dispatch(GET_RELEASEPROCESS_TRIGGERS, reiseterminId);
        });
    },
    async getTeilnehmerAndFluege(reiseterminId) {
      return this.$store.dispatch(GET_VORGAENGE_WITH_FLIGHTS_TEILNEHMER, {
        reiseterminId: reiseterminId,
      });
    },
    async loadTransferData(reiseterminId) {
      try {
        const transferDataResponse = await apiService.get(`/Reisetermin/${reiseterminId}/transfergruppen`);
        this.transferData = transferDataResponse?.data?.result || {};
      } catch (error) {
        console.error('Fehler beim Laden der Transferdaten:', error);
        this.transferData = {};
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card.card-custom > .card-body {
  padding: 16px;
}
</style>
